import {
  MockOfferClaimStruct,
  MockOfferStruct,
} from "graphql/__generated__/globalTypes";
import React from "react";
import TableWithCheckbox from "../../../components/TableWithCheckbox/TableWithCheckbox";
import { TableData } from "../../../utils/types";
import { claimColumns } from "../columns";

type Props = {
  claims: (MockOfferClaimStruct | null)[] | null | undefined;
  offer: MockOfferStruct | null;
};

const OfferClaims = ({ claims, offer }: Props) => {
  return (
    <div>
      <TableWithCheckbox
        columns={claimColumns}
        data={
          claims?.map((el) => ({
            ...el,
            claim_share: el?.offer_claim_participants?.find(
              (el) => el?.offer_participant_id === offer?.offer_participant_id
            )?.claim_share,
            offer_claim_participant_id: el?.offer_claim_participants?.find(
              (el) => el?.offer_participant_id === offer?.offer_participant_id
            )?.offer_claim_participant_id,
            offer_participant_percentage: offer?.offer_participant_percentage,
            offer_participant_id: offer?.offer_participant_id,
            offer_id: offer?.offersoffer_id,
            reinsurer_id: offer?.reinsurer?.reinsurer_id,
            offer_from: offer?.offer?.offer_from,
          })) ?? []
        }
        setSelected={function (
          value: React.SetStateAction<TableData<any>>
        ): void {
          throw new Error("Function not implemented.");
        }}
        selected={[]}
        loading={false}
        error={undefined}
        setNumberOfRows={function (value: React.SetStateAction<number>): void {
          throw new Error("Function not implemented.");
        }}
        numberOfRows={0}
      />
    </div>
  );
};

export default OfferClaims;
